import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { IRadioGroupProps } from './IRadioGroupProps'

export const useRadioGroupValidationSchema = (props: IRadioGroupProps) => {
    const [schema, setSchema] = useState<Yup.StringSchema>();

    useEffect(() => {
        const { label, required } = props

        let schema = Yup.string()
        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);

        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
